<div class="container-fluid-page">
    <div class=" profile_details">
        <div class="container-fluid page">
            <!-- <div class="d-flex page__box p-3 mt-2">&nbsp;&nbsp;Unauthorized Page</div> -->
            <div class=" profile_details">
                <div class="page__content shadow p-3" style="min-height: calc(90vh - 80px);">
                    <!-- <div class="row" style="padding-top: 125px;"> -->
                        <div class="row" style="padding-top: 0px;">
                        <div class="col-md-12">
                            <img style="width:80%;" src="/assets/Cocnut3.png">
                        </div>
                        <div class="col-md-6" style="padding: 57px 44px;">
                            <div>
                                <!-- <h3>Unauthorized Access</h3> -->
                            </div>
                            <!-- <p style="font-size: medium;">
                                you don't have access to this functionality, please contact your Super Admin for details.
                            </p> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
<!-- </div> -->